import { type FC, type Dispatch, type SetStateAction } from 'react';
import PayBySecurePay from '../Payment/PayBySecurePay';
import { type SecurePayAccessCode } from '@/api/registration/payment';

interface SecurePayPaymentProps {
  isValid: boolean
  setErrors: Dispatch<SetStateAction<string[]>>
  options: SecurePayAccessCode
}

const SecurePayPayment: FC<SecurePayPaymentProps> = ({ isValid, setErrors, options }) => {
  return (
    <PayBySecurePay
      isValid={isValid}
      setErrors={setErrors}
      options={options}
    />
  );
};

export default SecurePayPayment;
